module.exports = __webpack_public_path__ + "img/RG_frente.9ec87ab6.svg";